import { ControlledMenu, MenuItem } from "@szhsin/react-menu";
import { Handle, Position } from "@xyflow/react";
import { useEffect, useState } from "react";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/zoom.css";
import { VariablesConstant } from "../../../../../constants/variables";
import { Dcs0101Service } from "../../../../../services/dcs/Dcs0101Service";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { showAndHideSpinner } from "../../../../../reducers/spinnerSlice";

export default function InstanceNode(props: any) {
  const [isOpen, setOpen] = useState<any>(false);
  const [anchorPoint, setAnchorPoint] = useState<any>({ x: 0, y: 0 });
  const [isCollector, setIsCollector] = useState<any>(false);

  const dispatch = useDispatch();
  useEffect(() => {
    setIsCollector(props.data.instanceTp === VariablesConstant.INSTANCE_TYPE_COLLECTION);
  }, []);

  const handleStart = () => {
    dispatch(showAndHideSpinner(true));
    if (isCollector) {
      Dcs0101Service.getInstance()
        .startColl({ connId: props.data.connection.id })
        .then((res: any) => {
          toast.success("Start collection successfully!");
        })
        .catch((err: any) => {
          toast.error("Start collection failed!");
        })
        .finally(() => {
          dispatch(showAndHideSpinner(false));
        });
    } else {
      Dcs0101Service.getInstance()
        .startDel({ connId: props.data.connection.id })
        .then((res: any) => {
          toast.success("Start delivery successfully!");
        })
        .catch((err: any) => {
          toast.error("Start delivery failed!");
        })
        .finally(() => {
          dispatch(showAndHideSpinner(false));
        });
    }
  };

  const handleStop = () => {
    dispatch(showAndHideSpinner(true));
    if (isCollector) {
      Dcs0101Service.getInstance()
        .stopColl({ connId: props.data.connection.id })
        .then((res: any) => {
          toast.success("Stop collection successfully!");
        })
        .catch((err: any) => {
          toast.error("Stop collection failed!");
        })
        .finally(() => {
          dispatch(showAndHideSpinner(false));
        });
    } else {
      Dcs0101Service.getInstance()
        .stopDel({ connId: props.data.connection.id })
        .then((res: any) => {
          toast.success("Stop delivery successfully!");
        })
        .catch((err: any) => {
          toast.error("Stop delivery failed!");
        })
        .finally(() => {
          dispatch(showAndHideSpinner(false));
        });
    }
  };

  const handleRestart = () => {
    dispatch(showAndHideSpinner(true));
    if (isCollector) {
      Dcs0101Service.getInstance()
        .restartColl({ connId: props.data.connection.id })
        .then((res: any) => {
          toast.success("Restart collection successfully!");
        })
        .catch((err: any) => {
          toast.error("Restart collection failed!");
        })
        .finally(() => {
          dispatch(showAndHideSpinner(false));
        });
    } else {
      Dcs0101Service.getInstance()
        .restartDel({ connId: props.data.connection.id })
        .then((res: any) => {
          toast.success("Restart delivery successfully!");
        })
        .catch((err: any) => {
          toast.error("Restart delivery failed!");
        })
        .finally(() => {
          dispatch(showAndHideSpinner(false));
        });
    }
  };

  return (
    <>
      <Handle type="source" position={Position.Right} />
      <Handle type="target" position={Position.Left} />
      <div
        onContextMenu={(e) => {
          if (typeof document.hasFocus === "function" && !document.hasFocus()) return;

          e.preventDefault();
          setAnchorPoint({ x: e.clientX, y: e.clientY });
          setOpen(true);
        }}>
        <div className="position-relative">
          <img src={require(isCollector ? "../../../../../../assets/images/hardware/collector.png" : "../../../../../../assets/images/hardware/delivery.png")} alt="" width={120} height={80} />
          {props.data.status === VariablesConstant.CONTAINER_RUNNING && <i className="position-absolute ic-running pi pi-spinner fs-3 ms-3 text-success"></i>}
          {(!props.data.status || props.data.status === VariablesConstant.CONTAINER_STOPPED) && <i className="position-absolute pi pi-stop-circle fs-3 ms-3 text-danger"></i>}
          <span className="node-title">{props.data.title}</span>
        </div>
        <ControlledMenu anchorPoint={anchorPoint} state={isOpen ? "open" : "closed"} direction="right" onClose={() => setOpen(false)}>
          {!props.data.status && (
            <MenuItem onClick={handleStart}>
              <i className="pi pi-play me-3"></i>Start
            </MenuItem>
          )}
          {props.data.status === VariablesConstant.CONTAINER_RUNNING && (
            <>
              <MenuItem onClick={handleStop}>
                <i className="pi pi-stop me-3"></i>Stop
              </MenuItem>
              <MenuItem onClick={handleRestart}>
                <i className="pi pi-refresh me-3"></i>Restart
              </MenuItem>
            </>
          )}
        </ControlledMenu>
      </div>
    </>
  );
}
